import React, { Component } from 'react';
import { Link, NavLink } from "react-router-dom";
import GlobalNav from '../GlobalNav/GlobalNav';
import './PageWrapper.scss';

const PageWrapper = (props) => 
    <div class="PageWrapper">
        <GlobalNav />
        { props.children }
    </div>

export default PageWrapper;